module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAyCAMAAACeXICkAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACFQTFRF////Tpzf8/j95/L7WqPhib3qfbboZqnjrNHwcbDluNfycGNaqwAAAFNJREFUeNrszEEOgCAMRNFpUQvc/8CCxkDCdMHSpH85LxngV6kHp2QPRKoHUubvrAOONIGJKQOUNjRaAVefjAD0IQKDFviIwEsUOllCFEUb3QIMAC+EARzqTHgIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./js-src/markdown-editor/modules/checkbox/checkbox.png
// module id = 45
// module chunks = 0 1